import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

const SafeIcon = ({ icon, ...props }) => {
  if (icon) {
    return React.createElement(icon, props);
  }
  return <FiAlertTriangle {...props} />;
};

export default SafeIcon;